import { EventParticipantImage } from '@frontend/sports/betting-offer/feature/model';

import { DropdownOption } from '../../dropdown/models';

export interface TrackingModel {
    currentRoute?: string;
    labelEvent?: string;
    actionEvent?: string;
    positionEvent: string;
    locationEvent?: string;
    eventDetails?: string;
    urlClicked?: string;
}

export const enum EventDetailsType {
    Goalscorer = 'goalscorer',
    Score = 'score',
}

export type MultiColumnDropdownOption = DropdownOption<DropdownOption[]> & { payload: DropdownOption[] };

export interface DropdownImage extends EventParticipantImage {
    id: string;
    sportId: number;
}

export interface ScorecastStorageItem {
    id: string;
    player: string;
    option?: string;
    expiryDate: number;
}

export const SCORECAST_LOCAL_STORAGE_KEY = 'scorecast';
export const ANY_OTHER_SCORE_MARKET_TEXT = 'any other score';
export const ANY_OTHER_SCORE_OPTION_KEY = 'any';
export const CLASS_SCORECAST_OPTION_GROUP = 'scorecast-option-group';
export const CLASS_LINE_SWITCHER_SWAP_DIALOG = '.line-switcher-swap-dialog';
